<template>
  <div class="grid grid-cols-3 space-x-2 mb-1">
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <span class="text-sm text-gray-400 w-32">
        Display Only
      </span>
      <span class="h-full w-3/4">
        user_id
      </span>
    </div>
    <div class="col-span-2 flex flex-row space-x-2 items-center">
      <input class="h-full w-3/4"
        v-model="formValues.value.input"
        disabled
        @change="() => {
          markPendingItem(formValues, 'value')
          valueChange()
        }"
      />
      <span
        v-if="pendingValue">
        *
      </span>
      <div class="grow"></div>
      <XButton class="bg-orange-200 p-1 w-4 h-4 justify-center"
        v-if="showDelete"
        @click="() => {
          deleteKeyValue()
          valueDelete()
        }"
      />
    </div>
  </div>
</template>

<script>
import XButton from '../../XButton.vue'

export default {
  props: {
    defaultValue: Object,
    value: undefined,
    showDelete: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    XButton
  },
  data() {
    return {
      formValues: {
        key: {
          current: undefined,
          input: undefined,
        },
        value: {
          current: undefined,
          input: undefined,
        },
      },

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    deleteKeyValue() {
      this.$emit('deleteKeyValue')
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
    markPendingItem(item, type) {
      if (type === 'key') {
        this.pendingKey = true
      }
      else if (type === 'value') {
        this.pendingValue = true
      }
      this.$emit('markPending', item, type)
    },
    onAddExistingKey(existingKey) {
      this.formValues.key.input = existingKey
      this.$emit('markPending', this.formValues, 'key')
    },
    valueChange() {
      try {
        this.$emit('valueChange', 'user_id', JSON.parse(this.formValues.value.input))
      }
      catch {
        this.$emit('valueChange', 'user_id', this.formValues.value.input)
      }
    },
    valueDelete() {
      this.$emit('valueDelete', 'user_id')
    },
  },
  mounted() {
    this.formValues = this.defaultValue
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    },
  }
}
</script>
